import { Link } from 'gatsby';
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

type Props = {
  title: string;
  imageSharp?: GatsbyTypes.ImageSharp;
  name: string;
  type: Page;
};

const SetSize = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% * 2 / 3);
`;

const Wrap = styled(Link)`
  grid-area: thumbnail;
  background: black;
  overflow: hidden;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  & > * {
    flex-grow: 1;
  }
`;
const Thumbnail: React.VFC<Props> = ({ imageSharp, name, title, type }) => (
  <SetSize>
    <Wrap to={`/${type}s/${name}`}>
      {imageSharp ? (
        <GatsbyImage
          image={imageSharp.gatsbyImageData}
          alt={`${title} thumbnail`}
          objectFit="contain"
        />
      ) : (
        <StaticImage
          src="../../images/default.png"
          alt={`${title} thumbnail`}
          placeholder="blurred"
          objectFit="contain"
        />
      )}
    </Wrap>
  </SetSize>
);

export default Thumbnail;
